<!-- ===== OFFCANVAS MODE (default) ===== -->
<ng-container *ngIf="!inModal">
  <div class="offcanvas offcanvas-end terms-offcanvas" tabindex="-1" id="termsOffcanvas"
       aria-labelledby="termsOffcanvasLabel">
    <div class="offcanvas-header terms-header">
      <div>
        <h5 class="offcanvas-title" id="termsOffcanvasLabel">
          {{ language === 'es' ? 'Términos y Condiciones de Inscripción' : 'Terms and Conditions of Enrollment & Use' }}
        </h5>
        <p class="terms-effective mb-0">
          {{ language === 'es' ? 'Vigente desde:' : 'Effective Date:' }} 05/15/2024 &mdash; Alliant Federation, LLC
        </p>
      </div>
      <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas"
              [attr.aria-label]="language === 'es' ? 'Cerrar' : 'Close'"></button>
    </div>

    <div class="offcanvas-body terms-body">
      <ng-container *ngTemplateOutlet="termsBody"></ng-container>
    </div>

    <div class="offcanvas-footer terms-footer">
      <button type="button" class="btn btn-primary btn-lg w-100" data-bs-dismiss="offcanvas">
        {{ language === 'es' ? 'Entendido, cerrar' : 'Understood, close' }}
      </button>
    </div>
  </div>
</ng-container>

<!-- ===== MODAL MODE (inModal = true) — renders body content only ===== -->
<ng-container *ngIf="inModal">
  <ng-container *ngTemplateOutlet="termsBody"></ng-container>
</ng-container>

<!-- ===== SHARED CONTENT ===== -->
<ng-template #termsBody>

  <!-- Intro -->
  <p class="terms-intro">
    <ng-container *ngIf="language === 'es'">
      Estos Términos rigen tu inscripción y uso de los servicios de Alliant Federation, LLC, incluyendo acceso a servicios de telesalud, productos de seguro y plataformas de comunicación.
      Al crear una cuenta, enviar tu información o inscribirte en cualquier plan, <strong>aceptas estos Términos</strong>.
    </ng-container>
    <ng-container *ngIf="language !== 'es'">
      These Terms govern your enrollment in and use of services provided by Alliant Federation, LLC, including access to telehealth services, insurance products, and communication platforms.
      By creating an account, submitting your information, or enrolling in any plan, <strong>you agree to these Terms</strong>.
    </ng-container>
  </p>

  <!-- Section 1 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '1. Rol de Alliant Federation' : '1. Role of Alliant Federation' }}
    </h6>
    <p class="terms-text">
      {{ language === 'es'
        ? 'Alliant Federation, LLC actúa como administrador de plan, facilitador y plataforma tecnológica. Proporciona acceso a servicios de telesalud y productos de seguro de terceros.'
        : 'Alliant Federation, LLC acts as a plan administrator, facilitator, and technology platform. Provides access to telehealth services and third-party insurance products.' }}
      <strong>{{ language === 'es' ? 'No es una compañía de seguros.' : 'It is NOT an insurance company.' }}</strong>
    </p>
    <div class="alert terms-alert-info" role="note">
      <strong>{{ language === 'es' ? 'Alliant NO:' : 'Alliant does NOT:' }}</strong>
      <ul class="mb-0 mt-1">
        <li>{{ language === 'es' ? 'Garantiza cobertura ni pago de reclamaciones' : 'Guarantee coverage or claim payment' }}</li>
        <li>{{ language === 'es' ? 'Toma decisiones sobre reclamaciones' : 'Make claim determinations' }}</li>
        <li>{{ language === 'es' ? 'Controla decisiones de suscripción' : 'Control underwriting decisions' }}</li>
      </ul>
    </div>
  </div>

  <!-- Section 2 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '2. Aviso de Cobertura de Seguro' : '2. Insurance Coverage Disclosure' }}
    </h6>
    <div class="alert terms-alert-warning" role="alert">
      <strong>{{ language === 'es' ? 'IMPORTANTE:' : 'IMPORTANT:' }}</strong>
      <ul class="mb-0 mt-1">
        <li>{{ language === 'es' ? 'El seguro ofrecido NO cumple con la ACA (PPACA)' : 'The insurance offered is NOT ACA (PPACA) compliant' }}</li>
        <li>{{ language === 'es' ? 'Puede no satisfacer los requisitos de seguro médico de EE.UU.' : 'It may not satisfy U.S. health insurance requirements' }}</li>
        <li>{{ language === 'es' ? 'Eres el único responsable de determinar si este plan cumple tus requisitos' : 'You are solely responsible for determining whether this plan meets your requirements' }}</li>
      </ul>
    </div>
  </div>

  <!-- Section 3 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '3. Alcance de los Servicios' : '3. Scope of Services' }}
    </h6>
    <p class="terms-subheading">
      {{ language === 'es' ? '(a) Telesalud' : '(a) Telehealth Services' }}
    </p>
    <ul class="terms-list">
      <li>{{ language === 'es' ? 'Consultas virtuales con proveedores licenciados' : 'Virtual consultations with licensed providers' }}</li>
      <li>{{ language === 'es' ? 'Navegación y coordinación de atención' : 'Care navigation and coordination' }}</li>
      <li>{{ language === 'es' ? 'Orientación médica no urgente' : 'Non-emergency medical guidance' }}</li>
    </ul>
    <p class="terms-subheading">
      {{ language === 'es' ? '(b) Cobertura de Seguro' : '(b) Insurance Coverage' }}
    </p>
    <ul class="terms-list">
      <li>{{ language === 'es' ? 'Productos de seguro médico internacional o limitado' : 'International or limited medical insurance products' }}</li>
      <li>{{ language === 'es' ? 'Sujeto a términos y exclusiones estrictas' : 'Subject to strict policy terms and exclusions' }}</li>
    </ul>
    <p class="terms-subheading">
      {{ language === 'es' ? '(c) Comunicación y Soporte' : '(c) Communication & Support' }}
    </p>
    <ul class="terms-list">
      <li>{{ language === 'es' ? 'SMS, WhatsApp, llamadas de voz y correo electrónico' : 'SMS, WhatsApp, voice calls, and email' }}</li>
      <li>{{ language === 'es' ? 'Interacciones asistidas por IA y por humanos' : 'AI-assisted and human-assisted interactions' }}</li>
    </ul>
  </div>

  <!-- Section 4 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '4. Aviso Médico y de Telesalud' : '4. Telehealth & Medical Disclaimer' }}
    </h6>
    <div class="alert terms-alert-warning" role="alert">
      <strong>{{ language === 'es' ? 'En caso de emergencia médica:' : 'If you experience a medical emergency:' }}</strong><br>
      {{ language === 'es'
        ? 'Llama al 911 o ve a la sala de emergencias más cercana de inmediato.'
        : 'Call 911 or go to the nearest emergency facility immediately.' }}
    </div>
    <ul class="terms-list">
      <li>{{ language === 'es' ? 'Los servicios no son para emergencias ni condiciones que amenazan la vida' : 'Services are not intended for medical emergencies or life-threatening conditions' }}</li>
      <li>{{ language === 'es' ? 'La telesalud tiene limitaciones frente a la atención presencial' : 'Telehealth has limitations compared to in-person care' }}</li>
      <li>{{ language === 'es' ? 'Los resultados médicos no están garantizados' : 'Medical outcomes are not guaranteed' }}</li>
    </ul>
  </div>

  <!-- Section 5 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '5. Limitaciones del Seguro y Responsabilidades' : '5. Insurance Limitations & User Responsibilities' }}
    </h6>
    <p class="terms-subheading">{{ language === 'es' ? '(a) Condiciones Preexistentes' : '(a) Pre-Existing Conditions' }}</p>
    <ul class="terms-list">
      <li>{{ language === 'es' ? 'Generalmente excluidas de la cobertura' : 'Generally excluded from coverage' }}</li>
      <li>{{ language === 'es' ? 'Solo situaciones de "inicio agudo" limitadas pueden ser cubiertas bajo condiciones estrictas' : 'Only limited "acute onset" situations may be covered under strict conditions' }}</li>
    </ul>
    <p class="terms-subheading">{{ language === 'es' ? '(b) Requisitos de Pre-Certificación' : '(b) Pre-Certification Requirements' }}</p>
    <p class="terms-text">
      {{ language === 'es'
        ? 'Ciertos servicios requieren aprobación previa del asegurador. El incumplimiento puede resultar en beneficios reducidos (ej. 50%) o sin cobertura.'
        : 'Certain services require advance approval by the insurer. Failure to comply may result in reduced benefits (e.g., 50%) or no coverage at all.' }}
    </p>
    <p class="terms-subheading">{{ language === 'es' ? '(c) Beneficios Basados en Aprobación' : '(c) Approval-Based Benefits' }}</p>
    <div class="alert terms-alert-info" role="note">
      {{ language === 'es'
        ? 'Algunos servicios (incluyendo evacuación y transporte) requieren autorización previa y coordinación con el asegurador. Sin aprobación = sin cobertura.'
        : 'Some services (including evacuation and transportation) require prior authorization and coordination with the insurer. No approval = no coverage.' }}
    </div>
  </div>

  <!-- Section 6 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '6. Sin Garantía de Cobertura' : '6. No Guarantee of Coverage' }}
    </h6>
    <p class="terms-text">
      {{ language === 'es'
        ? 'Alliant no garantiza que algún servicio médico sea cubierto, que las reclamaciones sean aprobadas, ni que ocurra un reembolso. Las decisiones de cobertura las toma exclusivamente la aseguradora.'
        : 'Alliant does not guarantee that any medical service will be covered, that claims will be approved, or that reimbursement will occur. Coverage decisions are made solely by the insurance carrier.' }}
    </p>
  </div>

  <!-- Section 7 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '7. Sistemas de IA y Automatización' : '7. AI & Automated Systems Disclosure' }}
    </h6>
    <ul class="terms-list">
      <li>{{ language === 'es' ? 'Puedes interactuar con sistemas automatizados o de IA' : 'You may interact with automated or AI systems' }}</li>
      <li>{{ language === 'es' ? 'Las respuestas de IA son solo informativas y no constituyen consejo médico' : 'AI responses are informational only — not medical advice' }}</li>
      <li>{{ language === 'es' ? 'Las llamadas e interacciones pueden ser grabadas para calidad y cumplimiento' : 'Calls and interactions may be recorded for quality and compliance' }}</li>
    </ul>
  </div>

  <!-- Section 8 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '8. Consentimiento de Comunicaciones (TCPA / WhatsApp / SMS)' : '8. Communication Consent (TCPA / WhatsApp / SMS)' }}
    </h6>
    <p class="terms-text">
      {{ language === 'es'
        ? 'Al enviar tu información, consientes expresamente recibir comunicaciones de Alliant vía llamadas telefónicas (incluyendo sistemas automatizados y de voz IA), SMS, WhatsApp y correo electrónico.'
        : 'By submitting your information, you expressly consent to receive communications from Alliant via phone calls (including automated and AI voice systems), SMS, WhatsApp, and email.' }}
    </p>
    <div class="alert terms-alert-info" role="note">
      <ul class="mb-0">
        <li>{{ language === 'es' ? 'Pueden aplicarse cargos por mensajes y datos' : 'Message and data rates may apply' }}</li>
        <li>{{ language === 'es' ? 'El consentimiento no es condición de compra' : 'Consent is not a condition of purchase' }}</li>
        <li>{{ language === 'es' ? 'Para cancelar SMS/WhatsApp: responde STOP' : 'To opt out of SMS/WhatsApp: Reply STOP' }}</li>
      </ul>
    </div>
  </div>

  <!-- Section 9 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '9. Pagos y Facturación' : '9. Payments & Billing' }}
    </h6>
    <ul class="terms-list">
      <li>{{ language === 'es' ? 'Aceptas pagar todas las primas y tarifas de servicio aplicables' : 'You agree to pay all applicable premiums and service fees' }}</li>
      <li>{{ language === 'es' ? 'Debes mantener información de pago válida' : 'Maintain valid payment information' }}</li>
      <li>{{ language === 'es' ? 'El incumplimiento de pago puede resultar en terminación de cobertura o suspensión de servicios' : 'Failure to pay may result in termination of coverage or suspension of services' }}</li>
    </ul>
  </div>

  <!-- Section 10 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '10. Declaraciones del Usuario' : '10. User Representations' }}
    </h6>
    <ul class="terms-list">
      <li>{{ language === 'es' ? 'Toda la información proporcionada es verdadera, precisa y completa' : 'All information provided is true, accurate, and complete' }}</li>
      <li>{{ language === 'es' ? 'Estás autorizado para inscribirte a ti mismo y a cualquier dependiente' : 'You are authorized to enroll yourself and any dependents' }}</li>
      <li>{{ language === 'es' ? 'Proporcionar información falsa puede resultar en denegación de reclamaciones o terminación de cobertura' : 'Providing false information may result in denial of claims or termination of coverage' }}</li>
    </ul>
  </div>

  <!-- Section 11 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '11. Privacidad y Uso de Datos' : '11. Privacy & Data Use' }}
    </h6>
    <p class="terms-text">
      {{ language === 'es'
        ? 'Tu información se maneja conforme a nuestra Política de Privacidad e implementamos salvaguardas consistentes con HIPAA (donde aplique) y estándares de seguridad de la industria.'
        : 'Your information is handled in accordance with our Privacy Policy. We implement safeguards consistent with HIPAA (where applicable) and industry security standards.' }}
    </p>
  </div>

  <!-- Section 12 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '12. Limitación de Responsabilidad' : '12. Limitation of Liability' }}
    </h6>
    <p class="terms-text">
      {{ language === 'es'
        ? 'En la máxima medida permitida por la ley, Alliant Federation no es responsable por resultados médicos, denegación de reclamaciones, falta de cobertura ni daños indirectos o consecuentes.'
        : 'To the fullest extent permitted by law, Alliant Federation is not liable for medical outcomes, insurance claim denials or delays, failure to obtain coverage, or indirect or consequential damages.' }}
    </p>
  </div>

  <!-- Section 13 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '13. Terminación y Cancelación' : '13. Termination & Cancellation' }}
    </h6>
    <p class="terms-text">
      {{ language === 'es'
        ? 'Podemos suspender o terminar el acceso por violación de estos Términos, falta de pago o mal uso de los servicios. Puedes cancelar en cualquier momento, sujeto a los términos de la póliza y ciclos de facturación.'
        : 'We may suspend or terminate access for violation of these Terms, non-payment, or misuse. You may cancel at any time, subject to policy terms and billing cycles.' }}
    </p>
  </div>

  <!-- Section 14 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '14. Ley Aplicable' : '14. Governing Law' }}
    </h6>
    <p class="terms-text">
      {{ language === 'es'
        ? 'Estos Términos se rigen por las leyes del Estado de Indiana, consistente con la póliza de seguro subyacente.'
        : 'These Terms are governed by the laws of the State of Indiana, consistent with the underlying insurance policy.' }}
    </p>
  </div>

  <!-- Section 15 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '15. Cambios a los Términos' : '15. Changes to Terms' }}
    </h6>
    <p class="terms-text">
      {{ language === 'es'
        ? 'Podemos actualizar estos Términos en cualquier momento. Los cambios se comunicarán por sitio web, correo electrónico o notificaciones de la plataforma. El uso continuo constituye aceptación.'
        : 'We may update these Terms at any time. Updates will be communicated via website, email, or platform notifications. Continued use constitutes acceptance.' }}
    </p>
  </div>

  <!-- Section 16 — highlighted -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '16. Reconocimiento y Consentimiento' : '16. Acknowledgment & Consent' }}
    </h6>
    <div class="alert terms-alert-consent" role="note">
      <strong>{{ language === 'es' ? 'Al marcar la casilla y enviar tu inscripción, confirmas que:' : 'By checking the box and submitting your enrollment, you confirm that:' }}</strong>
      <ul class="mb-0 mt-1">
        <li>{{ language === 'es' ? 'Has leído y aceptas estos Términos' : 'You have read and agree to these Terms' }}</li>
        <li>{{ language === 'es' ? 'Entiendes las limitaciones de la cobertura de seguro' : 'You understand the limitations of insurance coverage' }}</li>
        <li>{{ language === 'es' ? 'Consientes comunicaciones e interacciones con IA' : 'You consent to communications and AI interactions' }}</li>
        <li>{{ language === 'es' ? 'Reconoces que las decisiones de cobertura las toma el asegurador, no Alliant' : 'You acknowledge that coverage decisions are made by the insurer, not Alliant' }}</li>
      </ul>
    </div>
  </div>

  <!-- Section 17 -->
  <div class="terms-section">
    <h6 class="terms-section-title">
      {{ language === 'es' ? '17. Trabajadores Patrocinados por Empleador / H-2A' : '17. Employer-Sponsored / H-2A Worker Disclosure' }}
    </h6>
    <ul class="terms-list">
      <li>{{ language === 'es' ? 'La cobertura puede ser proporcionada por un empleador o tercero' : 'Coverage may be provided through an employer or third party' }}</li>
      <li>{{ language === 'es' ? 'Los beneficios pueden variar según el estado de empleo' : 'Benefits may vary based on employment status' }}</li>
      <li>{{ language === 'es' ? 'Los servicios de telesalud complementan, pero no reemplazan, las obligaciones del empleador' : 'Telehealth services supplement, but do not replace, employer obligations' }}</li>
    </ul>
  </div>

</ng-template>
